import { render, staticRenderFns } from "./PostHighFive.vue?vue&type=template&id=33549a6a&scoped=true&lang=html&"
import script from "./PostHighFive.vue?vue&type=script&lang=js&"
export * from "./PostHighFive.vue?vue&type=script&lang=js&"
import style0 from "./PostHighFive.vue?vue&type=style&index=0&id=33549a6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33549a6a",
  null
  
)

export default component.exports